"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchContext = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const shortid_1 = __importDefault(require("shortid"));
const http_requests_1 = require("../http-requests");
const store_1 = require("../../store");
const pageConfig_1 = require("../../store/ducks/pageConfig");
const AppContextProvider_1 = require("./AppContextProvider");
const helpers_1 = require("../helpers");
const pesquisa_1 = require("../../store/ducks/pesquisa");
const const_1 = require("../const");
const hooks_1 = require("../hooks");
const GlobalEvent_1 = __importDefault(require("../events/GlobalEvent"));
const axios_1 = __importDefault(require("axios"));
const SearchContext = (0, react_1.createContext)(undefined);
const SearchContextProvider = ({ children, consultaRx, guiasPesquisaRx, ultimoLogRx }) => {
    const [searchTerm, setSearchTerm] = (0, react_1.useState)();
    const [loadingSearch, setLoadingSearch] = (0, react_1.useState)(false);
    const changeSearchTerm = (0, react_1.useCallback)((term) => setSearchTerm(term), []);
    const changeLoadingSearch = (0, react_1.useCallback)((loadingSearch) => setLoadingSearch(loadingSearch), []);
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const [lastSearchForm, setLastSearchForm] = (0, react_1.useState)();
    const { selectedTab } = (0, AppContextProvider_1.useAppContext)();
    const { getAll } = (0, hooks_1.usePrefiterParams)();
    const [ordenacao, setOrdenacao] = (0, react_1.useState)();
    const opcoesResultadoRx = (0, react_redux_1.useSelector)((state) => state.pesquisa.opcoesResultado);
    const opcoesConsultaRx = (0, react_redux_1.useSelector)((state) => state.pesquisa.opcoesConsulta);
    const { params: paginatedSearchParams, filterParams: paginatedSearchFilters, } = (0, hooks_1.usePesquisaPaginadaParams)();
    const [rep, setRep] = (0, react_1.useState)(null);
    const dispatch = (0, react_redux_1.useDispatch)();
    const paginatedSearchControl = (0, react_1.useRef)(false);
    const [orderBy, setOrderBy] = (0, react_1.useState)(undefined);
    const [perPage, setPerPage] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        const cancelTokenSrc = axios_1.default.CancelToken.source();
        http_requests_1.ConsultaAPI.ordenacao(cancelTokenSrc.token)
            .then(response => {
            const { data } = response;
            if (data && (data === null || data === void 0 ? void 0 : data.length)) {
                const firstItem = data[0].codigo;
                dispatch((0, pesquisa_1.changeOpcoesResultado)(Object.assign(Object.assign({}, opcoesResultadoRx), { ordenacaoCombo: firstItem, ordenacao: firstItem === 'ano_publicacao' ? 'D' : 'C' })));
                setOrdenacao(data);
            }
        })
            .catch(error => {
            if (!axios_1.default.isCancel(error))
                helpers_1.APIHelper.tratarErro(error);
        });
        return () => cancelTokenSrc.cancel();
    }, []);
    const changeRep = (rep) => setRep(rep);
    /*useEffect(() => {
        console.log({rep})
    }, [rep]);

     useEffect(() => {
         console.log({ultimoLogRx})
     }, [ultimoLogRx]);*/
    const [lastQuery, setLastQuery] = (0, react_1.useState)(null);
    const [currentQuery, setCurrentQuery] = (0, react_1.useState)(null);
    const changeOrderBy = (orderCode) => setOrderBy(orderCode);
    const changePerPage = (perPage) => setPerPage(perPage);
    const isPaginatedSearch = (0, react_1.useMemo)(() => selectedTab !== 'pesquisa_avancada' && [null, 'local'].includes(rep) && (guiasPesquisaRx && !!(guiasPesquisaRx === null || guiasPesquisaRx === void 0 ? void 0 : guiasPesquisaRx.find(guia => guia.codigo === selectedTab && guia.usa_consulta_paginada))), [guiasPesquisaRx, selectedTab, rep]);
    (0, react_1.useEffect)(() => {
        const searchParams = new URLSearchParams(history.location.search);
        let rep = searchParams.get('rep');
        rep = rep ? decodeURIComponent(rep) : null;
        setRep(rep !== null && rep !== void 0 ? rep : null);
    }, [history.location]);
    /* useEffect(() => {
         console.log({
             rep,
         });
     }, [rep]);*/
    (0, react_1.useEffect)(() => {
        if (selectedTab === 'arquivo')
            return;
        const searchParams = new URLSearchParams(history.location.search);
        const research = searchParams.get('research');
        if (research) {
            searchParams.delete('research');
            history.replace({
                pathname: `/${selectedTab}`,
                search: searchParams.toString(),
            });
            const fields = getFieldsBySearchTab();
            if (fields !== null) {
                if (validateSearchFields(fields)) {
                    search(fields);
                }
            }
        }
    }, [history.location, selectedTab]);
    (0, react_1.useEffect)(() => {
        if (consultaRx &&
            consultaRx !== 'error' &&
            consultaRx.searchVersion === const_1.VERSAO_PESQUISA_PAGINADA &&
            location.pathname === `/${selectedTab}`) {
            paginatedSearchControl.current = true;
        }
    }, [paginatedSearchParams, paginatedSearchFilters]);
    (0, react_1.useEffect)(() => {
        if (paginatedSearchControl.current) {
            const fields = getFieldsBySearchTab();
            if (fields !== null) {
                search(fields, false, false);
            }
            paginatedSearchControl.current = false;
        }
    }, [paginatedSearchControl.current]);
    const getPrefilterParams = (currentForm) => {
        const queryParams = getAll();
        const { id_biblioteca, id_colecao, tipo_obra, id, cr } = queryParams;
        let fields = {};
        if (id_biblioteca && !currentForm.biblioteca)
            fields.biblioteca = id_biblioteca;
        if (cr && !currentForm.bib_virtual)
            fields.bib_virtual = cr;
        if (id_colecao && !currentForm.colecao)
            fields.colecao = id_colecao;
        if (tipo_obra && !currentForm.cod_tipo_obra)
            fields.cod_tipo_obra = tipo_obra;
        if (id && !currentForm.id_campus)
            fields.id_campus = id;
        return fields;
    };
    const search = (0, react_1.useCallback)((form_1, urlParams_1, ...args_1) => __awaiter(void 0, [form_1, urlParams_1, ...args_1], void 0, function* (form, urlParams, shouldGenerateSearchId = true, cancelToken) {
        if (loadingSearch)
            return;
        const { ordenacao: direction, ordenacaoCombo: orderBy } = opcoesResultadoRx;
        dispatch((0, pesquisa_1.limparFiltros)());
        if (!form.orderBy) {
            form.orderBy = orderBy;
            urlParams.orderBy = orderBy;
        }
        if (!form.direction) {
            form.direction = direction;
            urlParams.direction = direction;
        }
        setResearchDone(true);
        setLoadingSearch(true);
        /**
         * Preenche o state legado
         */
        fillLegacyState(form);
        form.search_id =
            !shouldGenerateSearchId && consultaRx
                ? consultaRx.id
                : shortid_1.default.generate();
        if (!form.search_tab)
            form.search_tab = selectedTab;
        if (selectedTab === 'pesquisa_geral' &&
            (urlParams === null || urlParams === void 0 ? void 0 : urlParams.rep) === 'rede_pergamum_oai') {
            setLastSearchForm(Object.assign(Object.assign({}, form), { coluna_um: urlParams.for }));
        }
        else {
            setLastSearchForm(form);
        }
        const searchParams = new URLSearchParams(history.location.search);
        if (urlParams) {
            Object.keys(urlParams).forEach((key) => {
                const value = urlParams[key];
                if (value) {
                    searchParams.set(key, encodeURIComponent(value));
                }
            });
        }
        const repInUrl = searchParams.get('rep');
        if (repInUrl && !(urlParams === null || urlParams === void 0 ? void 0 : urlParams.rep)) {
            searchParams.delete('rep');
        }
        const repBases = searchParams.get('repBases');
        if (repBases && !(urlParams === null || urlParams === void 0 ? void 0 : urlParams.repBases)) {
            searchParams.delete('repBases');
        }
        history.replace({
            pathname: `/${form.search_tab}`,
            search: searchParams.toString(),
        });
        form = Object.assign(Object.assign({}, form), getPrefilterParams(form));
        return new Promise((resolve, reject) => {
            try {
                http_requests_1.ConsultaAPI.buscarConsulta(form.search_tab, form, history.location, () => {
                    if (selectedTab === 'pesquisa_avancada') {
                        if (form.ordenacao) {
                            changeOrderBy(form.ordenacao);
                        }
                        if (form.perPage) {
                            changePerPage(form.perPage);
                            dispatch((0, pesquisa_1.changeOpcoesResultado)(Object.assign(Object.assign({}, opcoesResultadoRx), { quantPag: parseInt(form.perPage, 10) })));
                        }
                    }
                    store_1.Store.dispatch((0, pageConfig_1.toggleLoading)(false));
                    setLoadingSearch(false);
                    // Scroll automático para os resultados da pesquisa
                    setTimeout(() => {
                        const consultaContent = document.querySelector('.consultaContent');
                        if (consultaContent) {
                            consultaContent.scrollIntoView({
                                block: 'start',
                                inline: 'nearest',
                                behavior: 'smooth',
                            });
                        }
                    }, 300);
                    resolve();
                    setLastQuery(decodeURIComponent(urlParams === null || urlParams === void 0 ? void 0 : urlParams.q));
                }, isPaginatedSearch, 
                //@ts-ignore
                cancelToken);
            }
            catch (error) {
                reject(error);
            }
        });
    }), [history, selectedTab, loadingSearch, isPaginatedSearch, opcoesResultadoRx]);
    const [researchDone, setResearchDone] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        setLastSearchForm(undefined);
    }, [selectedTab]);
    (0, react_1.useEffect)(() => {
        if (ordenacao && (ordenacao === null || ordenacao === void 0 ? void 0 : ordenacao.length) > 0) {
            const firstItem = ordenacao[0].codigo;
            dispatch((0, pesquisa_1.changeOpcoesResultado)(Object.assign(Object.assign({}, opcoesResultadoRx), { ordenacaoCombo: firstItem, ordenacao: firstItem === 'ano_publicacao' ? 'D' : 'C' })));
        }
    }, [ordenacao, selectedTab]);
    const getQueryParams = () => {
        const params = new URLSearchParams(location.search);
        const queryParams = {};
        params.forEach((value, key) => {
            queryParams[key] = decodeURIComponent(value);
        });
        return queryParams;
    };
    (0, react_1.useEffect)(() => {
        var _a;
        const fields = getFieldsBySearchTab();
        if ((fields === null || fields === void 0 ? void 0 : fields.base) == 'target_gedweb')
            setResearchDone(false);
        //console.log(fields)
        if (fields !== null) {
            if (validateSearchFields(fields)) {
                search(fields, (_a = getQueryParams()) !== null && _a !== void 0 ? _a : undefined);
            }
        }
    }, [history.location,]);
    const fillLegacyState = (form) => {
        const opcoesConsulta = [];
        switch (selectedTab) {
            case 'pesquisa_geral':
            case 'e_books':
            case 'autoridades':
            case 'acessibilidade':
                opcoesConsulta.push({
                    option: form.coluna_um,
                    termo: form.termo_pesquisa,
                });
                break;
            case 'arquivo':
            case 'pesquisa_avancada':
            case 'atos_normativos':
            case 'jurisprudencia':
                if (form.termo_pesquisa && form.coluna_um) {
                    const linha1 = {
                        option: form.coluna_um,
                        termo: form.termo_pesquisa,
                        condition: form.condicao_um,
                    };
                    opcoesConsulta.push(linha1);
                }
                if (form.condicao_um &&
                    form.termo_pesquisa_dois &&
                    form.coluna_dois) {
                    const linha2 = {
                        option: form.coluna_dois,
                        termo: form.termo_pesquisa_dois,
                        condition: form.condicao_dois,
                    };
                    opcoesConsulta.push(linha2);
                }
                if (form.condicao_dois &&
                    form.termo_pesquisa_tres &&
                    form.coluna_tres) {
                    const linha3 = {
                        option: form.coluna_tres,
                        termo: form.termo_pesquisa_tres,
                    };
                    opcoesConsulta.push(linha3);
                }
                break;
            case 'novas_aquisicoes':
                opcoesConsulta.push({
                    option: form.coluna_um,
                    termo: form.termo_pesquisa,
                });
                break;
            case 'plano_ensino':
                break;
            case 'multimeios':
                opcoesConsulta.push({
                    option: form.coluna_um,
                    termo: form.termo_pesquisa,
                });
                break;
            default:
                opcoesConsulta.push({
                    option: form.coluna_um,
                    termo: form.termo_pesquisa,
                });
                break;
        }
        dispatch((0, pesquisa_1.changeSearchOptions)(opcoesConsulta));
    };
    const validateSearchFields = (form) => {
        const commonSearch = [
            'pesquisa_geral',
            'e_books',
            'autoridades',
            'acessibilidade',
            'multimeios'
        ];
        const otherSearch = [
            'arquivo',
            'pesquisa_avancada',
            'atos_normativos',
            'jurisprudencia',
        ];
        if (form.search_tab) {
            if (commonSearch.includes(form.search_tab)) {
                if (helpers_1.StringHelper.isBlank(form.termo_pesquisa) ||
                    helpers_1.StringHelper.isBlank(form.coluna_um)) {
                    return false;
                }
            }
            else if (otherSearch.includes(form.search_tab)) {
                if (helpers_1.StringHelper.isBlank(form.termo_pesquisa) ||
                    helpers_1.StringHelper.isBlank(form.coluna_um)) {
                    return false;
                }
                if (form.termo_pesquisa_dois) {
                    if (helpers_1.StringHelper.isBlank(form.termo_pesquisa_dois) ||
                        form.condicao_um === undefined ||
                        form.condicao_um === '-1') {
                        return false;
                    }
                }
                if (form.termo_pesquisa_tres) {
                    if (helpers_1.StringHelper.isBlank(form.termo_pesquisa_tres) ||
                        form.condicao_dois === undefined ||
                        form.condicao_dois === '-1') {
                        return false;
                    }
                }
                if (form.search_tab === 'pesquisa_avancada' &&
                    helpers_1.StringHelper.isBlank(form.tipo_termos)) {
                    return false;
                }
            }
            else if (form.search_tab === 'novas_aquisicoes') {
                if (helpers_1.StringHelper.isBlank(form.coluna_um))
                    return false;
                if (form.coluna_um !== 'TODOS' &&
                    helpers_1.StringHelper.isBlank(form.termo_pesquisa))
                    return false;
            }
            else if (form.search_tab === 'plano_ensino') {
                if (form.tipo_termos === undefined)
                    return false;
                if (form.termo_pesquisa === undefined ||
                    helpers_1.StringHelper.isBlank(form.termo_pesquisa))
                    return false;
                if (form.coluna_um === undefined ||
                    helpers_1.StringHelper.isBlank(form.coluna_um))
                    return false;
                if (form.termo_pesquisa_dois !== undefined) {
                    if (helpers_1.StringHelper.isBlank(form.termo_pesquisa_dois))
                        return false;
                    if (form.coluna_dois === undefined ||
                        helpers_1.StringHelper.isBlank(form.coluna_dois))
                        return false;
                }
                if (form.termo_pesquisa_tres !== undefined) {
                    if (helpers_1.StringHelper.isBlank(form.termo_pesquisa_tres))
                        return false;
                    if (form.coluna_tres === undefined ||
                        helpers_1.StringHelper.isBlank(form.coluna_tres))
                        return false;
                }
            }
            if (isPaginatedSearch) {
                if (!form.page ||
                    Number.isNaN(Number(form.page)) ||
                    !form.perPage ||
                    Number.isNaN(Number(form.perPage))
                // ||
                // StringHelper.isBlank(form.orderBy) ||
                // StringHelper.isBlank(form.direction)
                )
                    return false;
            }
        }
        else {
            return false;
        }
        return true;
    };
    const getFieldsBySearchTab = (params) => {
        const queryParams = params !== undefined ? params : getQueryParams();
        if (Object.keys(queryParams).length === 0) {
            return null;
        }
        const { rep } = queryParams;
        let fields = null;
        const commonSearch = [
            'pesquisa_geral',
            'e_books',
            'autoridades',
            'acessibilidade',
            'novas_aquisicoes',
            'multimeios'
        ];
        const otherSearch = [
            'arquivo',
            'pesquisa_avancada',
            'atos_normativos',
            'jurisprudencia',
        ];
        if (commonSearch.includes(selectedTab)) {
            const { tipo_obra_total, for: forQuery, aut_id, index, } = queryParams;
            if (tipo_obra_total) {
                fields = {
                    termo_pesquisa: 'tipo_obra_total',
                    coluna_um: forQuery,
                    autoridade: aut_id,
                    indice: index,
                    tipo_obra_total: helpers_1.StringHelper.getWithCommaAtTheEnd(tipo_obra_total),
                };
            }
            else {
                const { q } = queryParams;
                fields = {
                    termo_pesquisa: q,
                    coluna_um: forQuery,
                    autoridade: aut_id,
                    indice: index,
                };
            }
            if (selectedTab === 'pesquisa_geral') {
                const { rep, repBases } = queryParams;
                if (rep) {
                    fields.base = rep;
                }
                if (repBases) {
                    fields.coluna_um = `${forQuery},${repBases}`;
                }
            }
        }
        else if (otherSearch.includes(selectedTab)) {
            const { q, for: forQuery, for2, q2, condition, for3, q3, condition2, } = queryParams;
            fields = {
                termo_pesquisa: q,
                coluna_um: forQuery,
            };
            if (for2 || q2 || condition) {
                fields = Object.assign(Object.assign({}, fields), { termo_pesquisa_dois: q2, coluna_dois: for2, condicao_um: condition });
            }
            if (for3 || q3 || condition2) {
                fields = Object.assign(Object.assign({}, fields), { termo_pesquisa_tres: q3, coluna_tres: for3, condicao_dois: condition2 });
            }
            if (selectedTab === 'pesquisa_avancada') {
                const { cr, keyword_type, local, idioma, ano_publicacao, ano_publicacao_final, comp_ano_publicacao, categoria, ordenacao, perPage, local_interna } = queryParams;
                if (cr) {
                    fields = Object.assign(Object.assign({}, fields), { bib_virtual: cr.toUpperCase() === 'S'
                            ? cr.toUpperCase()
                            : 'N' });
                }
                if (local) {
                    fields = Object.assign(Object.assign({}, fields), { local });
                }
                if (idioma) {
                    fields = Object.assign(Object.assign({}, fields), { idioma });
                }
                if (ano_publicacao) {
                    fields = Object.assign(Object.assign({}, fields), { ano_publicacao });
                }
                if (comp_ano_publicacao) {
                    fields = Object.assign(Object.assign({}, fields), { comp_ano_publicacao });
                }
                if (ano_publicacao_final) {
                    fields = Object.assign(Object.assign({}, fields), { ano_publicacao_final });
                }
                if (categoria) {
                    fields = Object.assign(Object.assign({}, fields), { categoria });
                }
                if (ordenacao) {
                    fields = Object.assign(Object.assign({}, fields), { ordenacao });
                }
                if (perPage) {
                    fields = Object.assign(Object.assign({}, fields), { perPage });
                }
                if (perPage) {
                    fields = Object.assign(Object.assign({}, fields), { perPage });
                }
                if (local_interna) {
                    fields = Object.assign(Object.assign({}, fields), { local_interna });
                }
                fields = Object.assign(Object.assign({}, fields), { tipo_termos: keyword_type });
            }
        }
        else if (selectedTab === 'plano_ensino') {
            const { curso, disciplina, campus, biblioteca, professor } = queryParams;
            fields = {
                tipo_termos: 99,
            };
            if (campus) {
                fields.cod_campus_selecao = campus;
            }
            if (biblioteca) {
                fields.biblioteca = biblioteca;
            }
            const items = [
                { coluna: 'CURSO', termo: curso },
                { coluna: 'DISCIPLINA', termo: disciplina },
                { coluna: 'PROFESSOR', termo: professor },
            ].filter(item => typeof item.termo !== 'undefined');
            const assoc = ['um', 'dois', 'tres'];
            items.forEach((item, index) => {
                // @ts-ignore
                fields[`coluna_${assoc[index]}`] = item.coluna;
                const stringEnd = index === 0 ? '' : `_${assoc[index]}`;
                // @ts-ignore
                fields[`termo_pesquisa${stringEnd}`] = item.termo;
                // @ts-ignore
                fields[`condicao_${assoc[index]}`] = 'AND';
            });
        }
        // Parametros de paginacao
        if (isPaginatedSearch) {
            const { page, perPage, orderBy, direction } = queryParams;
            fields = Object.assign(Object.assign({}, fields), { page,
                perPage,
                orderBy,
                direction });
            // if(!fields.orderBy){
            //     fields.orderBy = process.env.REACT_APP_CONSULTA_PAGINADA_ORDENACAO ?? process.env.ORDENACAO;
            // }
            for (const [key, value] of Object.entries(queryParams)) {
                if (key.startsWith('f') && key.length === 2) {
                    fields[key] = value;
                }
            }
        }
        if (fields !== null) {
            fields = Object.assign(Object.assign({}, fields), { search_tab: selectedTab, base: rep !== 'local' ? rep : '' });
        }
        return fields;
    };
    const makeAndRunSearch = (params) => {
        const fields = getFieldsBySearchTab(params);
        if (fields !== null) {
            if (isPaginatedSearch) {
                fields.page = 1;
                fields.perPage = 20;
                // fields.orderBy =  process.env.REACT_APP_CONSULTA_PAGINADA_ORDENACAO || process.env.ORDENACAO
                //fields.direction = 'C'
            }
            if (validateSearchFields(fields)) {
                search(fields, params);
            }
        }
    };
    const clearSearch = () => {
        GlobalEvent_1.default.emit("CLEAR_SEARCH");
        clearQueryParams();
    };
    const clearQueryParams = () => {
        window.history.replaceState(null, "", window.location.pathname);
    };
    const memoizedData = (0, react_1.useMemo)(() => ({
        changeSearchTerm,
        searchTerm,
        loadingSearch,
        changeLoadingSearch,
        search,
        lastSearchForm,
        makeAndRunSearch,
        researchDone,
        orderBy,
        changeOrderBy,
        perPage,
        changePerPage,
        getPrefilterParams,
        clearSearch,
        eventBus: GlobalEvent_1.default,
        rep,
        changeRep,
        ordenacao
    }), [
        searchTerm,
        loadingSearch,
        lastSearchForm,
        selectedTab,
        opcoesConsultaRx,
        researchDone,
        consultaRx,
        rep,
        orderBy,
        ordenacao,
        opcoesResultadoRx
    ]);
    return (react_1.default.createElement(SearchContext.Provider, { value: memoizedData }, children));
};
const useSearchContext = () => {
    const context = (0, react_1.useContext)(SearchContext);
    if (context === undefined)
        throw new Error('useSearchContext must be used within a SearchContextProvider');
    return context;
};
exports.useSearchContext = useSearchContext;
const mapStateToProps = (state) => ({
    statusRx: state.pageConfig.status,
    guiasPesquisaRx: state.pageConfig.guiasPesquisa,
    consultaRx: state.pesquisa.consulta,
    ultimoLogRx: state.pesquisa.log[state.pesquisa.log.length - 1],
});
// @ts-ignore
exports.default = (0, react_redux_1.connect)(mapStateToProps)((0, react_router_dom_1.withRouter)(SearchContextProvider));
